/**
 * Where the web app was opened from, passed in the URL fragment as `#origin=<origin>`.
 * Kept for the browser session, since the fragment is dropped on startup.
 */
const ORIGIN_KEY = 'appOrigin';

/** Opened from inside the iOS app, so prompts to download the app are hidden. */
const PD_IOS_ORIGIN = 'pd-ios';

// Fallback for when session storage is blocked
let memoryOrigin: string | null = null;

export function storeAppOrigin(origin: string): void {
  memoryOrigin = origin;
  try {
    sessionStorage.setItem(ORIGIN_KEY, origin);
  } catch {}
}

export function appOrigin(): string | null {
  try {
    return sessionStorage.getItem(ORIGIN_KEY) ?? memoryOrigin;
  } catch {
    return memoryOrigin;
  }
}

export function showAppDownload(): boolean {
  return appOrigin() !== PD_IOS_ORIGIN;
}
